import { locale } from 'icreate/common/validators/yup-locale';
import * as yup from 'yup';
import { ObjectSchema, object, string, number } from 'icreate/common/validators/index';
yup.setLocale(locale);

export const groupDisplayNameMaxLen = 50;

export class ChannelGroup {
    displayName: string;
    displayNumber: number;
    categoryId: string;
}

export function GroupValidator(existingRowNums: number[]): ObjectSchema<ChannelGroup> {
    return object({
        displayName: string().nonNullable().strict().required().max(groupDisplayNameMaxLen),
        displayNumber: number().nonNullable().integer().required().min(1).max(101).notOneOf(existingRowNums),
        categoryId: string().nonNullable().strict().required(),
    })
        .noUnknown()
        .strict();
}
